<template>
    <div class="flex flex-col justify-between bg-white rounded-md shadow-md hover:shadow-lg border-2 border-transparent hover:border-indigo-500 transition duration-100 px-4 py-3 "
        :class="{ 'opacity-50': section.disabled }"
    >
        <div>
            <div class="flex items-start justify-between">
                <div>
                    <div v-if="section.tags.length" class="text-xs font-medium mb-2">
                        <span v-for="(tag, index) in section.tags"
                            class="text-blue-500 hover:text-blue-700 cursor-pointer mr-2"
                            @click.stop="filterTag(tag.id)"
                        >
                            #{{ tag.name.toLowerCase() }}
                        </span>
                    </div>

                    <a class="no-underline"
                        :href="section.disabled ? 'https://personalitywizard.com/supporter' : ('/users/' + user_id + '/reportsections/' + section.id)">
                        <h2 class="text-black text-lg font-bold leading-tight my-1 pt-0 hover:text-blue-500">
                            {{ section.name }}
                        </h2>
                    </a>
                </div>

                <div class="flex-none">
                    <button
                        type="button"
                        class="-mr-2 -mt-1 p-0 bg-transparent focus:outline-none hover:text-red-500"
                        :class="section.is_favorite ? 'text-red-500' : 'text-gray-500'"
                        @click.stop="toggleFavorite"
                    >
                        <i aria-hidden="true" class="material-icons text-2xl block">
                            {{ section.is_favorite ? 'favorite' : 'favorite_border' }}
                        </i>
                    </button><br>
                    <div class="relative">
                        <polish-icon class="w-6 text-gray-700"></polish-icon>
                        <span class="absolute bottom-0 right-0 -mr-1 text-xs rounded-full bg-yellow-300 text-black font-bold w-4 h-4 text-center font-mono">{{ annotation_count || '0' }}</span>
                    </div>
                </div>
            </div>

            <p class="text-black text-sm leading-snug mb-1">
                {{ section.short_desc }}
            </p>

            <div class="flex text-xs leading-snug mb-1">
                <span class="flex-none font-semibold text-black mr-2">
                    Authors
                </span>

                <div class="flex flex-wrap">
                    <div v-for="(author, index) in section.authors"
                        class="font-medium text-green-600 hover:text-green-800 cursor-pointer mr-1"
                        @click.stop="filterAuthor(author.id)"
                    >
                        {{ author.first_name }} {{ author.last_name }}{{ index < section.authors.length - 1 ? ',' : '' }}
                    </div>
                </div>
            </div>

            <div class="flex text-xs leading-snug mb-1">
                <div class="flex-none font-semibold text-black mr-2">
                    Psych Model
                </div>

                <div class="flex flex-wrap">
                    <div v-for="(model, index) in section.psych_models"
                        class="font-medium text-yellow-600 hover:text-yellow-800 cursor-pointer mr-1"
                        @click.stop="filterPsychModel(model.id)"
                    >
                        {{ model.name }}{{ index < section.psych_models.length - 1 ? ',' : '' }}
                    </div>
                </div>
            </div>
        </div>

        <a class="bg-indigo-500 cursor-pointer hover:bg-indigo-600 leading-none py-3 rounded rounded-sm text-center text-sm text-white tracking-wider uppercase mt-5 no-underline"
        :href="section.disabled ? 'https://personalitywizard.com/supporter' : ('/users/' + user_id + '/reportsections/' + section.id)">
            {{ section.disabled ? 'Become a Supporter' : 'View Chapter' }}
        </a>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    props: {
        section: {},
        user_id: {},
        annotation_count: {},
    },

    methods: {
        viewSection() {
            if (this.section.disabled) {
                // load payment page
            } else {
                window.location.href = '/users/' + this.user_id + '/reportsections/' + this.section.id;
            }
        },
        toggleFavorite() {
            if (this.section.is_favorite) {
                this.clearFavorite();
            } else {
                this.setFavorite();
            }
        },
        setFavorite() {
            axios.post('/users/' + this.user_id
                + '/reportsections/' + this.section.id
                + '/favorites'
            ).then(() => {
                this.section.is_favorite = true;
            }).catch(error => {
                if (error.response.data.message) {
                    alert('Error: ' + error.response.data.message);
                }
            });
        },
        clearFavorite() {
            axios.delete('/users/' + this.user_id
                + '/reportsections/' + this.section.id
                + '/favorites'
            ).then(() => {
                this.section.is_favorite = false;
            }).catch(error => {
                if (error.response.data.message) {
                    alert('Error: ' + error.response.data.message);
                }
            });
        },
        filterAuthor(id) {
            this.$emit('filterAuthor', id);
        },
        filterPsychModel(id) {
            this.$emit('filterPsychModel', id);
        },
        filterTag(id) {
            this.$emit('filterTag', id);
        },
    },
}
</script>
